const HTML_CARD = `<article class="card is-fr">
                       <div class="card-header">
                           <div class="card-header-title">
                               Card Title
                           </div>
                       </div>
                       <div class="card-content">
                           <p>Card Body</p>
                       </div>
                   </article>
                   <p class="card-list-insert"></p>`;

export default [
    {
        command: 'cardList',
        title: 'Card List',
        icon: 'browser',
        commandHtml: `<p></p>
                      <div class="card-list is-inline is-fr">
                          ${HTML_CARD}
                      </div>
                      <p></p>`,
        enterInsertClass: 'card-list-insert',
        enterInsertHtml: HTML_CARD,
    },
];
